module.exports = __webpack_public_path__ + "static/img/p3-3.b72777f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/p3-3.jpg
// module id = 73Ta
// module chunks = 1